import dynamic from "next/dynamic";
import type { BlockComponent } from "./types";

export type { BlockProps } from "./types";



/*
export function mergeBlocks(dynamicBlocks: any[]) {
  const merged: { __component: string; }[] = [];

  dynamicBlocks.forEach((block) => {
    merged.push(block);

    if (block.__component === "blocks.service"){
      merged.push({ __component: "static.contact" });

    }
    
   
  });

  return merged;
}
  */

const Hero        = dynamic(() => import("../Hero")) as BlockComponent;
const About       = dynamic(() => import("../About")) as BlockComponent; 
const MapSection = dynamic(()=> import("../MapSection")) as BlockComponent;
const Stats = dynamic(()=> import("../Stats")) as BlockComponent;
const MenuList = dynamic(() => import("../MenuListe")) as BlockComponent;
const Aide = dynamic(()=> import("../Aide")) as BlockComponent;
const Service= dynamic(() =>import("../Service")) as BlockComponent;
const Faq = dynamic(() =>import("../Faq")) as BlockComponent;
const Contact = dynamic(() => import("../Contact")) as BlockComponent;
const MenuComposition = dynamic(()=> import("../MenuComposition")) as BlockComponent;
const PourquoiLMS = dynamic(()=> import("../PourquoiLMS")) as BlockComponent;
const BienEtre = dynamic(()=> import("../Bien-etre")) as BlockComponent;
const Etapes = dynamic(()=> import("../Etapes")) as BlockComponent;
const VideoCarousel = dynamic(()=> import("../VideoCarousel")) as BlockComponent;
const OffrirBloc = dynamic(() => import("../OffrirBlock")) as BlockComponent;
const Temoignage = dynamic(() => import("../Temoignage")) as BlockComponent;
const FaciliteMetier = dynamic(() => import("../FaciliteMetier")) as BlockComponent;
const Ressources = dynamic(() => import("../Ressources")) as BlockComponent;
const DemandeForm = dynamic(() => import("../DemandeForm")) as BlockComponent;

const PageBuilder = dynamic(() => import("../pageBuilder")) as BlockComponent;
const PresentationAgence = dynamic(() => import("../presentation-agence")) as BlockComponent;
const MenuMarche = dynamic(() => import("../MenuMarche")) as BlockComponent;
const EquipeLocale = dynamic(() => import("../EquipeLocal")) as BlockComponent;
const AboutEquipe = dynamic(() => import("../AboutEquipe")) as BlockComponent;
const Partenaire = dynamic(() => import("../Partenaire")) as BlockComponent;
const Saveur = dynamic(() => import("../Saveur")) as BlockComponent;
const ServiceDomicile = dynamic(() => import("../ServiceDomicile")) as BlockComponent;
const Metier = dynamic(() => import("../Metiers")) as BlockComponent;
const OffreEmploi = dynamic(() => import("../OffreEmploi")) as BlockComponent;
const EvenementsLocaux = dynamic(() => import("../EvenementsLocaux")) as BlockComponent;
const NosOffres = dynamic(() => import("../NosOffres")) as BlockComponent;
const SommesNous = dynamic(() => import("../Sommes-nous")) as BlockComponent;
const NosBeneficiaires = dynamic(() => import("../NosBeneficiaires")) as BlockComponent;
const SolutionLivraison = dynamic(() => import("../SolutionLivraison")) as BlockComponent;
const ContactezNous = dynamic(() => import("../ContactAgence")) as BlockComponent;
const MapAgence = dynamic( () => import("../MapAgence"),
  {
    ssr: false,
  },
) as BlockComponent;

export const BLOCKS_REGISTRY: Record<string, BlockComponent> = {
  "blocks.demande-form": DemandeForm,
  "blocks.hero":   Hero,
  "blocks.about":  About,
  "blocks.stats" : Stats,
  "blocks.map": MapSection,
  "blocks.menu": MenuList,
  "blocks.aide": Aide,
  "blocks.service": Service,
  "blocks.contact": Contact,
  "blocks.faq": Faq,
  "blocks.menu-composition": MenuComposition ,
  "blocks.info-menus": PourquoiLMS,
  "blocks.bien-etre": BienEtre,
  "blocks.etapes": Etapes ,
  "blocks.video-carousel": VideoCarousel,
  "blocks.offrir-bloc": OffrirBloc,
  "blocks.temoignage": Temoignage,
  "blocks.facilite-metier": FaciliteMetier,
  "blocks.ressources": Ressources,

  "blocks.presentation-agence": PresentationAgence,
  "blocks.menu-marche": MenuMarche,
  "blocks.equipe-local": EquipeLocale,
  "blocks.about-equipe": AboutEquipe,
  "blocks.partenaire-local": Partenaire,
  "blocks.saveur": Saveur,
  "blocks.service-domicile": ServiceDomicile,
  "blocks.metier": Metier,
  "blocks.offre-emploi": OffreEmploi,
  "blocks.evenements-locaux": EvenementsLocaux,
  "blocks.nos-offres": NosOffres,
  "blocks.sommes-nous": SommesNous,
  "blocks.nos-beneficiaires": NosBeneficiaires,
  "blocks.solution-livraison": SolutionLivraison,
  "blocks.contactez-nous": ContactezNous,

  "blocks.map-agence": MapAgence,
};
